import startOfDay from 'date-fns/startOfDay';
import subDays from 'date-fns/subDays';
import { MovementsType, SearchType, TransactionsType } from 'v2/interfaces/financial';

export const TransactionTypesFilter = [
  {
    label: 'Todos',
    value: TransactionsType.ALL,
    type: [MovementsType.ENTRY, MovementsType.OUT]
  },
  {
    label: 'Cobranças Produtos/Serviços',
    value: TransactionsType.BILLING,
    type: [MovementsType.OUT]
  },
  {
    label: 'Chargeback',
    value: TransactionsType.CHARGEBACK,
    type: [MovementsType.ENTRY, MovementsType.OUT]
  },
  {
    label: 'Cashback do parcelamento',
    value: TransactionsType.INSTALLMENT_SETTLEMENT,
    type: [MovementsType.ENTRY]
  },
  {
    label: 'Estorno',
    value: TransactionsType.REVERSAL,
    type: [MovementsType.ENTRY]
  },
  {
    label: 'Ganhos',
    value: TransactionsType.EARNINGS,
    type: [MovementsType.ENTRY]
  },
  {
    label: 'Reembolso',
    value: TransactionsType.REFUND,
    type: [MovementsType.OUT]
  },
  {
    label: 'Tarifas',
    value: TransactionsType.FEES,
    type: [MovementsType.OUT]
  },
  {
    label: 'Transferências',
    value: TransactionsType.TRANSFERS,
    type: [MovementsType.OUT]
  },
  {
    label: 'Outros',
    value: TransactionsType.OTHERS,
    type: [MovementsType.ENTRY, MovementsType.OUT]
  }
];

export const MovementTypesFilter = [
  {
    label: 'Todos',
    value: MovementsType.ALL
  },
  {
    label: 'Entrada',
    value: MovementsType.ENTRY
  },
  {
    label: 'Saída',
    value: MovementsType.OUT
  }
];

export const SearchTypeFilter = [
  {
    label: 'Todos',
    value: SearchType.ALL
  },
  {
    label: 'Fatura',
    value: SearchType.INVOICE,
    placeholder: 'Informe o número da fatura'
  },
  {
    label: 'Produto',
    value: SearchType.PRODUCT,
    placeholder: 'Informe o ID do produto'
  },
  {
    label: 'E-mail do comprador',
    value: SearchType.EMAIL,
    placeholder: 'Informe o e-mail do comprador'
  },
  {
    label: 'Nome do comprador',
    value: SearchType.NAME,
    placeholder: 'Informe o nome do comprador'
  },
  {
    label: 'CPF/CNPJ do comprador',
    value: SearchType.DOCUMENT,
    placeholder: 'Informe o CPF/CNPJ do comprador'
  }
];

export const PresetRanges = [
  {
    value: '7',
    label: '7 dias'
  },
  {
    value: '15',
    label: '15 dias'
  },
  {
    value: '30',
    label: '30 dias'
  },
  {
    value: '60',
    label: '60 dias'
  },
  {
    value: '90',
    label: '90 dias'
  }
];

const today = startOfDay(new Date());

export const calendarPreset = [
  {
    id: 'week',
    text: '7 dias',
    start: subDays(today, 6),
    end: today
  },
  {
    id: 'halfMonth',
    text: '15 dias',
    start: subDays(today, 14),
    end: today
  },
  {
    id: 'month',
    text: '30 dias',
    start: subDays(today, 29),
    end: today
  },
  {
    id: 'twoMonth',
    text: '60 dias',
    start: subDays(today, 59),
    end: today
  },
  {
    id: 'threeMonth',
    text: '90 dias',
    start: subDays(today, 89),
    end: today
  }
];
